import React from "react";
import { Link } from "react-router-dom";
import { DefaultButtonStyles } from "./SquareButton";

function ButtonLink({ to, children, className, onClick }) {
  return (
    <Link
      to={to}
      className={`${DefaultButtonStyles} block ${className}`}
      onClick={onClick}
    >
      {children}
    </Link>
  );
}

export default ButtonLink;
